import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import handleError from "@lib/helpers/handleError";

export default function useTopLeads({
  days = 14,
  perPage = 10,
  page = 1,
  includeTeam = false,
  enabled = true,
} = {}) {
  const api = useAxios();
  const { isPending, error, data, isPlaceholderData } = useQuery({
    queryKey: ["top-leads", days, perPage, page, includeTeam],
    queryFn: () =>
      api.get(
        `/top-leads?days=${days}&per_page=${perPage}&page=${page}&include_team=${includeTeam}`
      ),
    placeholderData: keepPreviousData,
    enabled,
  });

  handleError(error);

  const leads = data?.data.data ?? [];
  const meta = data?.data.meta ?? {};
  const lastPage = meta.last_page ?? 0;
  const hasMore = (meta.last_page > page ?? false) && !isPlaceholderData;

  return { leads, meta, lastPage, hasMore, isLoading: isPending };
}
